import { GlobalContext } from '../../../../../utils/globalprovider.js';
import SimplePopup from '../../../../../components/bases/popup/simplePopup.js';

import React from 'react';
import './edit-subtitle.css';

import { DOUBLE_HEIGHT_RATIO, drawMixin } from './actions/draw.js';
import { functionsMixin } from '../common/mixin.js';

import { join, first, cloneDeep, isEqual } from 'lodash';

import {
  addChar,
  addHebrewOrArabicChar,
} from './actions/char.js';

import { 
  addCommonChar, 
  addCommonHebrewOrArabicChar, 
  addSpace,
  addHyphen,  
  onReturnToLineWithHypen,
  addPeriod,
  removeUnsecableSpace,
  groupWordsByUnsecableSpace,
  groupWordsWithoutSpace,
  onConversionToInitial,
  onUpperOrLowerCase,
  addQuotes,
  addApostrophes,
  addOrRemoveLetter,
  invertPeriodAndComma,
  invertALetter,
  hyphenateTwoWords,
  replaceHyphenate,
  addOrRemoveLetterWithApostrophe,
  addOrRemoveApostropheToLetter,
  replaceLetter,
  addOrRemoveLeToWord,
} from '../common/actions/char.js';

import {
  onMoveCursorLetterByLetter,
  onMoveCursorToLeft,
  onMoveCursorToRight,
  onMoveCursorToDown,
  onMoveCursorToUp,
  onMoveWordByWord,
  onGoToStartOrEndOfSubtitle,
  onGoToStartOrEndOfLigne,
  onGoToStartOrEndOfWord,
} from '../common/actions/cursor.js';

import {
  onSetDialog,
  onMoveSubtitle,
  onMoveSubtitleToLeft,
  onMoveSubtitleToRight,
  onMoveSubtitleToDown,
  onMoveSubtitleToUp,
  onMoveSubtitleTo,
  onRotateWord,
  onRotateWordToUp,
  onRotateWordToDown,
  onMoveLineToUp,
  onMoveLineToDown,
} from '../common/actions/move.js';

import {
  onDoubleClick,
  onMouseMove,
  onMouseUp,
  onMouseDown,
  onClick,
} from './actions/mouse.js';

import {
  onBackspace,
  onBackspaceLeftToRight,
  onSetColor,
  onSelect,
  onSelectLeftOrRight,
  onSelectTopOrBottom,
  onSelectUpOrDownSentence,
  onSelectLetterByLetter,
  onDelete,
  onDeleteLeftToRight,
  onDeleteWord,
  onDeleteWordsUntil,
  onDeleteLine,
  onDeleteSelection,
  onEnter,
  onSelectWithCtrlA,
  onMarkWord,
  onCopy,
  onCut,
  onPaste,
  onTab,
  onChangeLineHeight,
} from '../common/actions/keyboard.js'

import { 
  addNewActionForUndo,
  cancelUndo,
  updateSubtitleAfterUndoOrRedo,
  addSubtitlesToUndoOrRedo, 
  onUndoOrRedo 
} from '../common/actions/undo-redo.js';

import {
  onApplyCorrection,
  onApplyCorrectionForSpelling,
  onApplyCorrectionForSpellingEnglish,
  onApplyCorrectionForGrammar,
  onCloseContextMenu,
  onShowContextMenu,
  onAddWordToDictionary,
  onIgnoreWordForCorrection,
  onIgnoreSuggestForCorrection,
} from './actions/corrector.js';

import { cloneSubtitle, wait } from '../common/functions.js';
import { getLisibility, getSubtitleErrorsInfos } from '../../../../../utils/checksubtitles.js';

import ContextMenu from './components/context-menu/context-menu.js';
import Tooltip from '../../../../../components/bases/tooltips/tooltip.js';
import Icon from '../../../../../components/bases/icone/icon.js';

class EditSubtitle extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    Object.assign(this, drawMixin);
    Object.assign(this, functionsMixin);

    // Props
    this.subtitle = null;
    this.subtitleNumber = null;
    this.readOnly = null;
    this.active = false;

    // Canvas
    this.backCanvas = document.createElement('canvas'); // canvas arrière plan
    this.foreCanvas = React.createRef(); // référence vers de canvas affiché // référence vers de canvas affiché
    this.foreCtx = null;
    this.backCtx = null;

    // Events
    this.onDraw = this.onDraw.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onShowPopup = this.onShowPopup.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onShowContextMenu = this.onShowContextMenu.bind(this);
    this.onApplyCorrection = this.onApplyCorrection.bind(this);
    this.onAddWordToDictionary = this.onAddWordToDictionary.bind(this);
    this.onIgnoreWordForCorrection = this.onIgnoreWordForCorrection.bind(this);
    this.onIgnoreSuggestForCorrection =
      this.onIgnoreSuggestForCorrection.bind(this);

    // Others props

    this.width = 0;
    this.height = 0;

    this.loaded = false; // si le canvas est chargé
    this.continue = false;
    this.forceRedraw = false;

    this.fontSize = 0;
    this.doubleFontSize = 0;
    this.lineHeight = 0;
    this.spaceWidth = 0;

    this.showCptCurs = true;
    this.cptCurs = 0;

    this.currentLine = null;
    this.currentWord = null;
    this.currentLetter = null;

    this.currentLineIndex = 0;
    this.currentWordIndex = 0;
    this.currentLetterIndex = 0;

    this.metricX = 10;
    this.metricY = 10;

    this.underSelection = false; // si c'est le texte est sous sélection
    this.wordsToSelect = []; // les mots en cours de sélection
    this.wordsSelected = []; // Les mots sélectionnés
    this.lettersToSelect = []; // Les lettres en cours de sélection

    this.commonErrors = [];
    this.wordsToSearch = null; // les mots recherchés à surligner
    this.currentPositionSearch = null;

    this.hasEmptyWord = false; // si on a créé un mot vide

    this.state = {
      popup: {
        display: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
       contextMenu: {
        display: false,
        x: 0,
        y: 0,
        word: null,
      },
    };
  }

  componentDidMount() {
    
    this.onResize();

    this.forceRedraw = true;
    this.continue = true;
    this.loaded = false;

    this.readOnly = this.props.readOnly;

    requestAnimationFrame(this.onDraw); // on lance le dessin du texte
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.readOnly !== this.props.readOnly) {
      this.readOnly = this.props.readOnly;
    }

    if (prevProps.isPlaying !== this.props.isPlaying) {
      this.readOnly = this.props.readOnly || this.props.isPlaying;
      if (!this.readOnly && this.active) {
        this.currentLineIndex = 0;
        this.currentWordIndex = 0;
        this.currentLetterIndex = 0;

        this.onMove();
      }
    }

    if (prevProps.showSubtitleNumber !== this.props.showSubtitleNumber) {
      this.onRefreshCanvas();
    }

    if (!isEqual(prevProps.videoDimensions, this.props.videoDimensions)) {
      this.onRefreshCanvas();
    }
  }

  initSubtitle(subtitleNumber, subtitle, active) {
    this.subtitleNumber = subtitleNumber;

    this.setCurrentSubtitle(subtitle, active, true);
  }

  clearCurrentSubtitle() {
    if (!this.readOnly){
      this.active = false;
    }
    this.subtitle = null;

    if (this.state.contextMenu.display) {
      this.onCloseContextMenu();
    }

    this.onRefreshCanvas();
  }

  refresh() {
    this.onRefreshCanvas();
  }

  setCurrentSubtitle(subtitle, active = false, init = false) {
    if (
      this.subtitle &&
      this.subtitle.id === subtitle.id &&
      this.active === active &&
      !init
    ) {
      return;
    }

    if (this.state.contextMenu.display) {
      this.onCloseContextMenu();
    }

    this.active = active;

    this.subtitle = cloneDeep(subtitle);
    this.props.onUpdateSubtitleOnState(cloneSubtitle(subtitle));

    this.underSelection = false;
    this.wordsToSelect = [];

    let lineIndex = this.subtitle.lines.findIndex((x) => x.words.length);
    if (lineIndex === -1) {
      lineIndex = 0;
    }

    this.currentLineIndex = lineIndex;
    this.currentWordIndex = 0;
    this.currentLetterIndex = 0;

    this.onRefreshCanvas();

    if (this.active && this.wordsToSearch && this.wordsToSearch.length && this.showSelectionSearch) {
      setTimeout(() => {
        this.setPositionOfSearch(this.currentPositionSearch, this.wordsToSearch);
        this.showSelectionSearch = false;
      }, 100);
    }
  }

  updateSubtitle(subtitle) {

    
    if (!subtitle) {
      this.subtitle = null;
      this.onRefreshCanvas();
      return;
    }

    const hasChanged = this.subtitle ? this.subtitle.id !== subtitle.id : false;

    this.subtitle = cloneDeep(subtitle);
    this.props.onUpdateSubtitleOnState(cloneSubtitle(subtitle));

     if (this.active && hasChanged) {
      
      this.onMove();
    }
    this.onRefreshCanvas();
  }

  // ***************************************************************************************
  // setWordsInError() permet d'affecter les mots en erreur sur le sous-titre
  // ***************************************************************************************
  setWordsInError(wordsInError) {
    let hasChanges = false;

    if (!this.subtitle || !this.subtitle.lines || !this.subtitle.lines.length){
      return;
    }
    
    const wordsSuggested = this.subtitle.lines
      .flatMap((l) => l.words)
      .filter((x) => x.suggest !== undefined);

    if (wordsSuggested.length) {
      wordsSuggested.forEach((word) => (word.suggest = undefined));      
      hasChanges = true;
    }

    wordsInError
      .filter((x) => x.subtitleId === this.subtitle.id)
      .forEach((wordInError) => {
        const line = this.subtitle.lines[wordInError.indexLine];
        if (line) {
          const word = line.words.find((x) => x.text === wordInError.text);
          if (word && word.suggest !== wordInError.suggest) {
            word.suggest = wordInError.suggest;
            hasChanges = true;
          }
        }
      });

    if (hasChanges) {
      this.onRefreshCanvas();
    }
  }

  // ***************************************************************************************
  // goToWord() permet d'aller directement au mot
  // ***************************************************************************************
  goToWord(timecode) {
    if (!this.active) {
      return;
    }

    const wordFounded = this.subtitle.lines
      .flatMap((l) => l.words)
      .find((x) => x.in === timecode);

    if (wordFounded) {

      this.currentLineIndex = wordFounded.indexLine;
      this.currentWordIndex = wordFounded.index;

      const { letters } = wordFounded;
      if (letters.length) {
        this.currentLetterIndex = first(letters).indexLetter;
      } else {
        this.currentLetterIndex = 0;
      }

      this.onRefreshCanvas();
    }
  }

  // ***************************************************************************************
  // setCommonErrors() appelée par l'application lors d'un chargement d'une nouvelle
  // liste d'erreurs de mots
  // ***************************************************************************************
  setCommonErrors(blob) {
    this.commonErrors = blob;
  }

  componentWillUnmount() {
    this.continue = false;
    this.loaded = false;
  }

  // ***************************************************************************************
  // onDraw()
  // cette fonction est appelée continuellement pour le dessin du texte
  // ***************************************************************************************
  getSubtitleDisplayed()
  {
    return this.subtitleNumber;
  }
  onDraw() {
    if (this.foreCanvas && this.foreCanvas.current) {
      if (this.forceRedraw && this.subtitle) {
        
          // Vérifiez que les dimensions du canvas sont valides
        if (this.backCanvas.width === 0 || this.backCanvas.height === 0) {
          console.warn('EditSubtitle : Canvas dimensions are invalid (width or height is 0). Redraw.');
        }

        this.drawCanvas();

        // si subtitleNumber est -1, on n'affiche rien, juste un canvas transparent
        if (this.subtitleNumber === -1) {
          this.forceRedraw = false;

          if (!this.loaded) {
            this.loaded = true;
          }

          return;
        }

        const {
          // marginBottom: dMarginBottom,
          marginLeft: dMarginLeft,
          marginRight: dMarginRight,
          marginTop: dMarginTop,
          marginBottom: dMarginBottom,
          borderColor,
          borderWidth,
        } = this.props.displayParameters;

        const {
          teletext,
          boxing,
          doubleHeight: spDoubleHeight,
          displayNumberOfLines,
          fontName,
        } = this.props.subtitleParameters;

        const { background, displayhposition, displayhposition2 } = this.props.playerParams;

        //const marginBottom = (parseFloat(dMarginBottom) / 100) * this.height;
        const marginLeft = (parseFloat(dMarginLeft) / 100) * this.width;
        const marginTop = (parseFloat(dMarginTop) / 100) * this.height;
        const marginRight = (parseFloat(dMarginRight) / 100) * this.width;
        
        this.metricX = marginLeft;
        this.metricY = marginTop;

        let currentX = marginLeft;
        let currentY = marginTop + this.lineHeight;

        let indexWord = 0;

        for (let i = 1; i < displayNumberOfLines + 1; i++) {
          // dessiner le numéro de ligne
          if (this.props.showSubtitleNumber) {
            this.backCtx.font = `${ this.fontSize}px ${teletext ? "Courier New" : fontName}`;
            this.backCtx.fillStyle = '#FFF';
            this.backCtx.fillText(i.toString(), currentX, currentY);
          }

          const indexLine = this.subtitle.lines.findIndex(
            (x) => x.verticalPos === i
          );

          if(indexLine === -1) {
            currentY += this.lineHeight;
            continue;
          }

          const line = this.subtitle.lines[indexLine];

          if (line) {

            const doubleHeight = line.doubleHeight ?? spDoubleHeight;
            
            line.index = indexLine;

            const { words } = line;

            const sentence = join(
              words.map((x) => x.text),
              ' '
            );

            this.backCtx.font = `${doubleHeight ? this.doubleFontSize : this.fontSize}px ${teletext ? "Courier New" : fontName}`;
            const stretch = doubleHeight ? 1 : DOUBLE_HEIGHT_RATIO;

            this.spaceWidth = this.backCtx.measureText(' ').width * stretch;
            const textWidth = this.backCtx.measureText(sentence).width * stretch;

            line.width = textWidth;

            let startX = this.getCoordinateX(line, teletext);

            line.startX = startX;
            line.startY = currentY;

            // Dessiner le rectangle
            if ((teletext || background || boxing) && words.length) {
              const y = doubleHeight ? currentY + this.lineHeight : currentY;
              this.drawBoxing(startX, y, textWidth, doubleHeight);
            }

            let indexLetter = 0;

            for (let j = 0; j < words.length; j++) {
              const word = line.words[j];

              const metricsWord = this.backCtx.measureText(word.text);

              word.index = j;
              word.indexWord = indexWord;
              word.indexLine = indexLine;
              //word.strech = stretch;
              word.width = metricsWord.width * stretch + this.spaceWidth;
              word.height = 
                metricsWord.actualBoundingBoxAscent +
                metricsWord.actualBoundingBoxDescent;

              const startY = doubleHeight
                ? currentY + this.lineHeight / 2
                : currentY;

              word.startX = startX;
              word.endX = startX + word.width;
              word.startY = startY;
              word.endY = startY + this.lineHeight;

              indexLetter = this.createLettersForWord(
                word,
                startX,
                startY,
                indexLetter,
                stretch
              );

              // dessiner la bordure
              if (!teletext && !boxing) {
                this.backCtx.strokeStyle = borderColor;
                this.backCtx.lineWidth = 3; // parseFloat(borderWidth);
                this.strokeWord(word, stretch);
              }

              // dessiner le mot recherché
              if (this.wordsToSearch && this.wordsToSearch.length) {
                const wordsFounded = this.wordsToSearch.filter(
                  (x) => x.id === this.subtitle.id
                );

                if (wordsFounded.length > 0) {
                  wordsFounded.forEach((wordFounded) => {
                    const wordToSearch = wordFounded.words.find(
                      (x) =>
                        x.indexWord === word.indexWord &&
                        x.inWord === word.in &&
                        x.text === word.text
                    );

                    if (wordToSearch) {
                     this.drawSearchWord(this.backCtx, 
                        word, 
                        doubleHeight,
                        wordToSearch.startIndex, 
                        wordToSearch.endIndex);
                    }
                  });
                }


                /*const wordToHightlight = this.wordsToSearch.words.find(x => x.indexWord === word.indexWord);
                if (wordToHightlight) {
                  this.drawSearchWord(this.backCtx, word, wordToHightlight.startIndex, wordToHightlight.endIndex);
                }*/
              }

              // dessiner la sélection
              if (this.underSelection) {
                const y = doubleHeight
                  ? this.lineHeight + this.lineHeight * 0.5
                  : this.lineHeight;
                const height = doubleHeight
                  ? this.lineHeight * 2
                  : this.lineHeight;

                if (
                  this.wordsToSelect.length &&
                  this.wordsToSelect.some(
                    (w) =>
                      w.index === word.index &&
                      w.indexWord === word.indexWord &&
                      w.indexLine === word.indexLine &&
                      w.text === word.text
                  )
                ) {
                  this.drawSelectionWord(
                    word.startX,
                    word.startY - y,
                    word.width,
                    height,
                    word
                  );
                }

                if (this.lettersToSelect.length) {
                  const letters = this.lettersToSelect.filter(
                    (x) =>
                      x.indexWord === word.index &&
                      x.indexLine === word.indexLine
                  );

                  if (letters.length) {
                    letters.forEach((l) => {
                      this.drawSelectionLetter(
                        l.x,
                        l.y - y,
                        l.width,
                        height
                      );
                    });
                  }
                }
              }

              if (word.suggest) {
                this.drawSuggestErrors(this.backCtx, word);
              }

              // dessiner le mot
              this.drawWord(word, stretch);

              startX += word.width;
              indexWord++;
            }

             var whpossize = 0;
             var startVX = 0;
             if (displayhposition) {
              this.backCtx.font = `18px ${fontName}`;

              this.backCtx.strokeStyle = borderColor;
              this.backCtx.lineWidth = parseFloat(borderWidth);
              this.backCtx.strokeText(
                line.verticalPos,
                startVX,
                currentY
              );

              this.backCtx.fillStyle = '#FFF';
              this.backCtx.fillText(
                line.verticalPos,
                startVX,
                currentY
              );

              whpossize = this.backCtx.measureText(line.verticalPos).width;
            }
          }

          if (displayhposition2) {



            if (line.align === 3)
            {

              var halign = line.horizontalPos;
              if (teletext)
                halign = Math.floor(line.horizontalPos * 40 / 100);




              this.backCtx.font = `12px ${fontName}`;
                this.backCtx.strokeStyle = borderColor;
                this.backCtx.lineWidth = parseFloat(borderWidth);
                this.backCtx.strokeText(
                  halign,
                  startVX + whpossize + 1,
                  currentY
                );

                this.backCtx.fillStyle = '#AAA';
                this.backCtx.fillText(
                  halign,
                  startVX + whpossize + 1,
                  currentY
                );
              }
              else
                this.drawAlignSymbol(this.backCtx, line.align, startVX + whpossize + 2, currentY - 14 ,18,18);

          }

          currentY += this.lineHeight;
        }

        if (this.subtitle.mark) {
          const firstLine = first(this.subtitle.lines);
          if (firstLine.words.length) {
            this.drawMarkWords(
              this.subtitle.mark,
              firstLine.startX,
              firstLine.startY
            );
          }
        }

        // Dessiner le délai (Afficher retard de sous-titre entre in et in du premier mot)
        this.drawDelay();

        this.forceRedraw = false;

        if (!this.loaded) {
          this.loaded = true;
        }
      }

     // this.foreCtx = this.foreCanvas.current.getContext('2d');
     // this.foreCtx.drawImage(this.backCanvas, 0, 0);
      this.drawCanvasWithDimension();
      
      
      if (this.active) {
        this.createCursor();
      }

      if (this.continue === true) {
        requestAnimationFrame(this.onDraw); // on lance le dessin du texte
      }
    }
  }

  // ***************************************************************************************
  // onResize()
  // cette fonction est appelée à chaque fois que l'application modifie la taille
  // du composant
  // ***************************************************************************************
  onResize() {
    if (this.foreCanvas && this.foreCanvas.current) {

      const width = 720;
      const height = 576;

      this.foreCanvas.current.width = width;
      this.foreCanvas.current.height = height;

      this.backCanvas.width = width;
      this.backCanvas.height = height;

      this.width = width;
      this.height = height;
    }
  }

  // ***************************************************************************************
  // onChange() Cette fonction doit être appelée à chaque fois que le script est modifié
  // ***************************************************************************************
  onChange() {
    this.subtitle.len = this.getNbChars();

    this.subtitle.lines.forEach((line) => {
      line.len = this.getSentence(line).length;
    });

    const subtitleCloned = cloneSubtitle(this.subtitle);
    subtitleCloned.lisibility = getLisibility(subtitleCloned, this.props.subtitleParameters);
    
    this.props.onChange(subtitleCloned);
    this.onRefreshCanvas();
  }

  // ***************************************************************************************
  // onMove() Cette fonction doit être appelée à chaque fois que le curseur change de mot
  // ***************************************************************************************
  onMove() {
    // on doit rafraichir le canvas car comme le fond est transparent, on doit le recréer
    this.onRefreshCanvas();

    if (!this.subtitle || !this.subtitle.lines) {
      return;
    }

    const words = this.getWords();
    if (!words.length) {
      this.props.onMove(this.subtitle.id, this.subtitle.in);
      return;
    }

    const currentLine = this.subtitle.lines[this.currentLineIndex];
    if (!currentLine) {
      return;
    }

    const currentWord = currentLine.words[this.currentWordIndex];
    if (!currentWord) {
      return;
    }

    this.props.onMove(this.subtitle.id, currentWord.in ?? this.subtitle.in);
  }
  

  // ***************************************************************************************
  // onSave() Cette fonction est appelée quand on appelle le raccourci SAVE
  // ***************************************************************************************
  onSave() {
    this.props.onSave();
  }

  // ***************************************************************************************
  // onRefreshCanvas() permet de rafraichir le canvas
  // ***************************************************************************************
  onRefreshCanvas() {
    // On réinitialise le canvas
    this.onResize();

    this.cptCurs = 0; // on force l'affichage du curseur clignotant

    // On force le dessin
    this.forceRedraw = true;
  }

  // ***************************************************************************************
  // getSubtitle() retourne Subtitle
  // ***************************************************************************************
  getSubtitle() {
    return cloneSubtitle(this.subtitle);
  }

  // ***************************************************************************************
  // processShortcut() appelée par l'application lors de l'appui sur une touche du clavier
  // correspondant à un raccourci.
  // ***************************************************************************************
  processShortcut(key, event) {

    // si la transcription est en mode readonly alors on ne doit pas éxécuter ces actions
    if (this.readOnly || !this.active) {
      return;
    }

    // si on a un mot vide, on le supprime et on refait l'action
    if (this.hasEmptyWord && key !== 'UNDO' && key !== 'REDO') {
      this.removeEmptyWord(key).then(() => this.processShortcut(key));
      return;
    }

    switch (key) {
      case 'SAVE':
        this.onSave();
        break;

      case 'UP':
      case 'DOWN':
      case 'LEFT':
      case 'RIGHT':
        this.onMoveCursorLetterByLetter(key);
        break;

      case 'SELECTLEFT':
      case 'SELECTRIGHT':
      case 'SELECTUP':
      case 'SELECTDOWN':
        this.onSelect(key);
        break;

      case 'SELECTUPSENTENCE':
      case 'SELECTDOWNSENTENCE':
        this.onSelectUpOrDownSentence(key);
        break;
      
      case 'SELECTLETTERBYLETTERONRIGHT':
      case 'SELECTLETTERBYLETTERONLEFT':
        this.onSelectLetterByLetter(key);
        break;

      case 'SELECTA':
        this.onSelectWithCtrlA();
        break;

     case 'STARTSUBTITLE':
      case 'ENDSUBTITLE':
        this.onGoToStartOrEndOfSubtitle(key);
        break;

      case 'STARTLINE':
      case 'ENDLINE':
        this.onGoToStartOrEndOfLigne(key);
        break;

      case 'STARTWORD':
      case 'ENDWORD':
        this.onGoToStartOrEndOfWord(key);
        break;

      case 'PREVIOUSWORD':
      case 'NEXTWORD':
        this.onMoveWordByWord(key === 'PREVIOUSWORD');
        break;

      case 'UNSECABLE':
        this.addChar(String.fromCharCode(0xa0));
        break;

      case 'DELETEUNSECABLE':
        this.removeUnsecableSpace();
        break;

      case 'SETDIALOG':
      case 'MOVEUP':
      case 'MOVEDOWN':
      case 'MOVELEFT':
      case 'MOVERIGHT':
      case 'MOVESUBTITLETOLEFT':
      case 'MOVESUBTITLETORIGHT':
      case 'MOVESUBTITLETOCENTER':
        this.onMoveSubtitle(key);
        break;

      case 'BACKSPACE':
         if (this.currentWord?.rtl) {
          this.onBackspaceLeftToRight();
          return;
         }
        
        this.onBackspace();
        break;

      case 'ENTER':
        this.onEnter();
        break;

      case 'DELETE':
        if (this.currentWord?.rtl) {
          this.onDeleteLeftToRight();
          return;
        }

        this.onDelete();
        break;

      case 'DELETEWORD':
        this.onDeleteWord();
        break;

      case 'DELETEWORDSUNTIL':
        this.onDeleteWordsUntil();
        break;

      case 'DELETELINE':
        this.onDeleteLine();
        break;

      case 'BLUE':
      case 'GREEN':
      case 'CYAN':
      case 'RED':
      case 'MAGENTA':
      case 'YELLOW':
      case 'WHITE':
        this.onSetColor(key);
        break;

      case 'CHECKWORD':
      case 'NEWST':
        this.onMarkWord(key);
        break;

      case 'UNDO':
      case 'REDO':
        this.onUndoOrRedo(key);
        break;

      case 'COPY':
        this.onCopy();
        break;

      case 'CUT':
        this.onCut();
        break;

      case 'PASTE':
        this.onPaste();
        break;

      case 'TAB':
        this.onTab();
        break;

      case 'ADDHYPHEN':
        this.addHyphen();
        break;

      case 'ADDPERIOD':
      case 'ADDPERIODANDNEWLINE':
        this.addPeriod(key === 'ADDPERIODANDNEWLINE');
        break;

      case 'GROUPBYUNSECABLESPACEWITHNEXTWORD':
      case 'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD':
        this.groupWordsByUnsecableSpace(
          key === 'GROUPBYUNSECABLESPACEWITHNEXTWORD'
        );
        break;

      case 'GROUPWORDSWITHOUTSPACE':
        this.groupWordsWithoutSpace();
        break;

      case 'CONVERSIONTOINITIAL':
      case 'CONVERSIONTOINITIALWITHOUTSPACE':
        this.onConversionToInitial(key === 'CONVERSIONTOINITIAL');
        break;

      case 'UPPERCASEORLOWERCASEONFIRSTLETTER':
      case 'UPPERCASEORLOWERCASEONSECONDLETTER':
      case 'UPPERCASEORLOWERCASEWITHDASH':
      case 'UPPERCASEONWORD':
      case 'LOWERCASEONWORD':
      case 'UPPERCASEORLOWERCASEONSENTENCE':
      case 'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD':
        this.onUpperOrLowerCase(key);
        break;

      case 'RETURNTOLINEWITHHYPHEN':
        this.onReturnToLineWithHypen();
        break;

      case 'ADDQUOTES':
        this.addQuotes();
        break;

      case 'ADDTWOAPOSTROPHES':
      case 'ADDONEAPOSTROPHE':
        this.addApostrophes(key === 'ADDONEAPOSTROPHE');
        break;

      case 'ADDORREMOVESLETTER':
      case 'ADDORREMOVENTLETTER':
        this.addOrRemoveLetter(key);
        break;

      case 'INVERTPERIODEANDCOMMA':
        this.invertPeriodAndComma();
        break;

      case 'INVERTA':
        this.invertALetter();
        break;

      case 'HYPHENATETWOWORDS':
        this.hyphenateTwoWords();
        break;

      case 'REPLACEHYPHENWITHSPACE':
      case 'REPLACEHYPHENWITHUNSECABLESPACE':
        this.replaceHyphenate(key === 'REPLACEHYPHENWITHUNSECABLESPACE');
        break;

      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T':
        this.addOrRemoveLetterWithApostrophe(key);
        break;

      case 'ADDORREMOVEAPOSTROPHETOLETTER_C':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_D':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_J':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_L':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_M':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_N':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_Q':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_S':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_T':
        this.addOrRemoveApostropheToLetter(key);
        break;

      case 'REPLACE_E':
      case 'REPLACE_Z':
      case 'REPLACE_R':
      case 'REPLACE_T':
        this.replaceLetter(key);
        break;

      case 'ADDORREMOVELETOWORD':
        this.addOrRemoveLeToWord();
        break;
      
      case 'ROTATEWORDTOUP':
      case 'ROTATEWORDTODOWN':
        this.onRotateWord(key);
        break;
      
      case 'TAKEWORDFROMLASTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMNEXTSUBTITLETOCURRENTSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETOPREVSUBTITLE':
      case 'TAKEWORDFROMCURRENTSUBTITLETONEXTSUBTITLE':
      case 'REGROUPSUBTITLE':
        this.props.onProcessShortcutToEditListSubtitle(key);
        break;

      case 'CUTASUBTITLE':
        this.props.onProcessShortcutToEditListSubtitle(key, {
          currentLineIndex: this.currentLineIndex,
          currentWordIndex: this.currentWordIndex,
          currentLetterIndex: this.currentLetterIndex,
        });
        break;
      
      case "CHANGELINEHEIGHT":
        this.onChangeLineHeight();
        break;
      
      

      default:
        return false;
    }

    return true;
  }

  createLettersForWord(word, x, y, indexLetter, stretch) {
    const letters = [];
    const text = word.text;

    if (text.length === 0) {
      indexLetter++;
      word.letters = [];
      return indexLetter;
    }

    for (let i = 0; i < text.length; i++) {
      const char = text.charAt(i);

      const metricsLetter = this.backCtx.measureText(char);
      const letter = {
        index: i,
        letter: char,
        width: metricsLetter.width * (stretch ?? 1),
        x: x,
        y: y,
        indexLetter,
        indexWord: word.index,
        indexLine: word.indexLine,
        lastChar: false,
      };

      if (i !== 0) {
        const lastLetter = letters[i - 1];
        letter.x = lastLetter.width + lastLetter.x;
      }

      letters.push(letter);
      indexLetter++;
    }

    const space = {
      index: letters.length,
      letter: ' ',
      width: this.spaceWidth,
      x: x,
      y: y,
      indexLetter,
      indexWord: word.index,
      indexLine: word.indexLine,
      lastChar: true,
    };

    if (letters.length === 0) {
      space.x = x;
    } else {
      const lastLetterOfWord = letters[letters.length - 1];
      space.x = lastLetterOfWord.width + lastLetterOfWord.x;
    }

    letters.push(space);
    indexLetter++;

    word.letters = letters;

    return indexLetter;
  }

  onShowPopup(value) {
    if (this.props.applicationsparams.subtitling.disablePopup) return;
    this.setState({
      popup: {
        display: true,
        ...value,
      },
    });

    setTimeout(() => {
      const element = document.querySelector(
        '.SimplePopupdarkBG [role="button"]'
      );

      if (element) {
        element.focus();
      }
    }, 100);
  }

  onClosePopup() {
    this.setState({
      popup: {
        display: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
    });
  }

  renderTimeCode() {
    if (!this.props.showTimecodes || !this.subtitle || this.props.isPlaying) {
      return <></>;
    }

    const errorInfo = getSubtitleErrorsInfos(this.subtitle);

    return (
      <div
        className="subtitle-timecodes-div"
        style={{ width: this.state.width }}
      >
        <div className="row">
          <div className="col left">
            <div className="row intervalles">
              {this.getIntervalleIn(errorInfo?.interbeforeBackcolor)}
            </div>
           <div
              className={
                'row timecode' +
                (this.props.timecode.isTyping &&
                !this.props.timecode.isTimeCodeOut
                  ? ' typing'
                  : '')
              }
            >
              {this.getTimeCode(
                this.subtitle.in,
                errorInfo?.tcinBackcolor,
                false
              )}
            </div>
          </div>
          <div className="col center">
            <div className="row icons">{this.getIcons(errorInfo?.icons)}</div>
            <div className="row timecode">
              <span className="white">
                {this.props.getIntervalString(
                  this.subtitle.in,
                  this.subtitle.out
                )}
              </span>
            </div>
          </div>
          <div className="col right">
            <div className="row intervalles">
              {this.getIntervalleOut(errorInfo?.interafterBackcolor)}
            </div>
            <div
              className={
                'row timecode' +
                (this.props.timecode.isTyping &&
                this.props.timecode.isTimeCodeOut
                  ? ' typing'
                  : '')
              }
            >
              {this.getTimeCode(
                this.subtitle.out,
                errorInfo?.tcoutBackcolor,
                true
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getTimeCode(currentTime, backcolor, outTime) {
    const classnames = [];
    if (backcolor) {
      classnames.push(`timecode-${backcolor}`);
    }

     if (
      this.props.timecode &&
      this.props.timecode.isTyping &&
      this.props.timecode.isTimeCodeOut === outTime &&
      this.props.timecode.newTimeCodeString
    ) {
      const classnamesString = classnames.join(' ');
      return (
        <span className={classnamesString}>
          {this.props.timecode.newTimeCodeString}
        </span>
      );
    }

    const classnamesString = classnames.join(' ');

    return (
      <span className={classnamesString}>
        {this.props.getTimeCodeString(currentTime)}
      </span>
    );
  }

  getIntervalleIn(backcolor) {
    const subtitles = this.props.getSubtitles();

    if (!subtitles.length || !this.subtitle) {
      return <></>;
    }

    const currentIndex = subtitles.findIndex((x) => x.id === this.subtitle.id);

    const prevSubtitle = subtitles[currentIndex - 1];
    const firstDelay = this.props.getIntervalString(
      prevSubtitle ? prevSubtitle.out : 0,
      this.subtitle.in
    );

    return (
      <span className={'small' + (backcolor ? ` intervalle-${backcolor}` : '')}>
        {firstDelay}
      </span>
    );
  }

  getIntervalleOut(backcolor) {
    const subtitles = this.props.getSubtitles();
    if (!subtitles.length || !this.subtitle) {
      return <></>;
    }

    const currentIndex = subtitles.findIndex((x) => x.id === this.subtitle.id);

    const nextSubtitle = subtitles[currentIndex + 1];
    const secondDelay = this.props.getIntervalString(
      this.subtitle.out,
      nextSubtitle ? nextSubtitle.in : 0
    );

    return (
      <span className={'small' + (backcolor ? ` intervalle-${backcolor}` : '')}>
        {secondDelay}
      </span>
    );
  }

  
  drawAlignSymbol(ctx, type, x, y, width = 18, height = 18) {
      // type : 0 = gauche, 1 = droite, 2 = centré

      ctx.save();

      // =========================
      // Fond gris arrondi
      // =========================

      const radius = Math.min(width, height) * 0.2;

      ctx.fillStyle = "#202020";

      ctx.beginPath();

      ctx.roundRect(
          x,
          y,
          width,
          height,
          radius
      );

      ctx.fill();


      // =========================
      // Zone intérieure du symbole
      // =========================

      const paddingX = width * 0.20;
      const paddingY = height * 0.20;

      const symbolX = x + paddingX;
      const symbolY = y + paddingY;

      const symbolWidth = width - paddingX * 2;
      const symbolHeight = height - paddingY * 2;


      // Nombre de lignes
      const lines = 4;

      // Épaisseur des lignes
      const lineHeight = Math.max(
          1,
          Math.round(symbolHeight * 0.12)
      );

      // Espacement vertical
      const spacing =
          (symbolHeight - lineHeight * lines) /
          (lines - 1);

      // Largeur des lignes courtes
      const shortWidth = symbolWidth * 0.65;

      // Couleur du symbole
      ctx.fillStyle = "#FFFFFF";


      // =========================
      // Dessin des lignes
      // =========================

      for (let i = 0; i < lines; i++) {

          const lineY =
              symbolY + i * (lineHeight + spacing);

          // Alternance longue / courte
          const lineWidth =
              (i % 2 === 0)
                  ? symbolWidth
                  : shortWidth;

          let lineX = symbolX;

          switch (type) {

              case 0: // Gauche
                  lineX = symbolX;
                  break;

              case 1: // Droite
                  lineX =
                      symbolX +
                      symbolWidth -
                      lineWidth;
                  break;

              case 2: // Centré
                  lineX =
                      symbolX +
                      (symbolWidth - lineWidth) / 2;
                  break;
          }

          ctx.fillRect(
              Math.round(lineX),
              Math.round(lineY),
              Math.round(lineWidth),
              lineHeight
          );
      }

      ctx.restore();
  }

  setPositionSearch(wordsToSearch, currentPosition, move) {
    this.wordsToSearch = wordsToSearch;
    this.currentPositionSearch = currentPosition;
    this.showSelectionSearch = move;

    if (this.active && wordsToSearch.length && move) {
      
      const wordToSearch = wordsToSearch[currentPosition];

      if (this.subtitle.id === wordToSearch.id){
        this.setPositionOfSearch(currentPosition, wordsToSearch);
        return;
      } 
        
      this.props.onMove(wordToSearch.id, wordToSearch.in);
      
    }

    this.onRefreshCanvas();
  }

  getIcons(icons) {
    if (!icons || !icons.length) {
      return <></>;
    }

    const lang = this.context.language;

    const tooltips = [];

    icons.forEach((icon, index) => {
      tooltips.push(
        <Tooltip
          text={lang === 'fr' ? icon.fr : icon.en}
          key={'tooltip-' + index}
        >
          <Icon
            image={icon.img}
            width="20"
            height="20"
            nochangecolor="true"
          ></Icon>
        </Tooltip>
      );
    });

    return tooltips;
  }

  render() {
    return (
      <div className="subtitle-full-div">
          {this.renderTimeCode()}
          <div className="subtitle-text-div" id="subtitleTextDiv">
            <canvas
              ref={this.foreCanvas}
              className="foreCanvas"
              style={{ zIndex: this.props.zIndex }}
              onDoubleClick={this.onDoubleClick}
              onClick={this.onClick}
              onMouseUp={this.onMouseUp}
              onMouseDown={this.onMouseDown}
              onMouseMove={this.onMouseMove}
              onContextMenu={this.onShowContextMenu}
            />
          </div>
        <SimplePopup
          display={this.state.popup.display}
          title={this.state.popup.title}
          text={this.state.popup.text}
          onCancel={this.onClosePopup}
          buttons={this.state.popup.buttons}
          showIcon={this.state.popup.showIcon}
          icon={this.state.popup.icon}
        />
        <ContextMenu
          contextMenu={this.state.contextMenu}
          onApplyCorrection={this.onApplyCorrection}
          onApplyCorrectionAll={this.onApplyCorrectionAll}
          onAddWordToDictionary={this.onAddWordToDictionary}
          onIgnoreWordForCorrection={this.onIgnoreWordForCorrection}
          onIgnoreSuggestForCorrection={this.onIgnoreSuggestForCorrection}
        ></ContextMenu>
      </div>
    );
  }
}

// Set cursor
EditSubtitle.prototype.onMoveCursorLetterByLetter = onMoveCursorLetterByLetter;
EditSubtitle.prototype.onMoveCursorToLeft = onMoveCursorToLeft;
EditSubtitle.prototype.onMoveCursorToRight = onMoveCursorToRight;
EditSubtitle.prototype.onMoveCursorToDown = onMoveCursorToDown;
EditSubtitle.prototype.onMoveCursorToUp = onMoveCursorToUp;
EditSubtitle.prototype.onMoveWordByWord = onMoveWordByWord;
EditSubtitle.prototype.onGoToStartOrEndOfSubtitle = onGoToStartOrEndOfSubtitle;
EditSubtitle.prototype.onGoToStartOrEndOfLigne = onGoToStartOrEndOfLigne;
EditSubtitle.prototype.onGoToStartOrEndOfWord = onGoToStartOrEndOfWord;

// Move
EditSubtitle.prototype.onSetDialog = onSetDialog;
EditSubtitle.prototype.onMoveSubtitle = onMoveSubtitle;
EditSubtitle.prototype.onMoveSubtitleToUp = onMoveSubtitleToUp;
EditSubtitle.prototype.onMoveSubtitleToDown = onMoveSubtitleToDown;
EditSubtitle.prototype.onMoveSubtitleToLeft = onMoveSubtitleToLeft;
EditSubtitle.prototype.onMoveSubtitleToRight = onMoveSubtitleToRight;
EditSubtitle.prototype.onMoveSubtitleTo = onMoveSubtitleTo;
EditSubtitle.prototype.onRotateWord = onRotateWord;
EditSubtitle.prototype.onRotateWordToUp = onRotateWordToUp;
EditSubtitle.prototype.onRotateWordToDown = onRotateWordToDown;
EditSubtitle.prototype.onMoveLineToUp = onMoveLineToUp;
EditSubtitle.prototype.onMoveLineToDown = onMoveLineToDown;

// Mouse
EditSubtitle.prototype.onDoubleClick = onDoubleClick;
EditSubtitle.prototype.onMouseMove = onMouseMove;
EditSubtitle.prototype.onMouseUp = onMouseUp;
EditSubtitle.prototype.onMouseDown = onMouseDown;
EditSubtitle.prototype.onClick = onClick;

// Keyboard
EditSubtitle.prototype.onSelect = onSelect;
EditSubtitle.prototype.onSelectLeftOrRight = onSelectLeftOrRight;
EditSubtitle.prototype.onSelectTopOrBottom = onSelectTopOrBottom;
EditSubtitle.prototype.onBackspace = onBackspace;
EditSubtitle.prototype.onBackspaceLeftToRight = onBackspaceLeftToRight;
EditSubtitle.prototype.onDelete = onDelete;
EditSubtitle.prototype.onDeleteLeftToRight = onDeleteLeftToRight;
EditSubtitle.prototype.onDeleteWord = onDeleteWord;
EditSubtitle.prototype.onDeleteWordsUntil = onDeleteWordsUntil;
EditSubtitle.prototype.onDeleteLine = onDeleteLine;
EditSubtitle.prototype.onEnter = onEnter;
EditSubtitle.prototype.onDeleteSelection = onDeleteSelection;
EditSubtitle.prototype.onSetColor = onSetColor;
EditSubtitle.prototype.onSelectWithCtrlA = onSelectWithCtrlA;
EditSubtitle.prototype.onMarkWord = onMarkWord;
EditSubtitle.prototype.onCopy = onCopy;
EditSubtitle.prototype.onCut = onCut;
EditSubtitle.prototype.onPaste = onPaste;
EditSubtitle.prototype.onTab = onTab;
EditSubtitle.prototype.onSelectUpOrDownSentence = onSelectUpOrDownSentence;
EditSubtitle.prototype.onSelectLetterByLetter = onSelectLetterByLetter;
EditSubtitle.prototype.onChangeLineHeight = onChangeLineHeight;

// Undo/Redo
EditSubtitle.prototype.addNewActionForUndo = addNewActionForUndo;
EditSubtitle.prototype.onUndoOrRedo = onUndoOrRedo;
EditSubtitle.prototype.updateSubtitleAfterUndoOrRedo =
  updateSubtitleAfterUndoOrRedo;
EditSubtitle.prototype.cancelUndo = cancelUndo;
EditSubtitle.prototype.addSubtitlesToUndoOrRedo = addSubtitlesToUndoOrRedo;

// Correcteur
EditSubtitle.prototype.onCloseContextMenu = onCloseContextMenu;
EditSubtitle.prototype.onShowContextMenu = onShowContextMenu;
EditSubtitle.prototype.onApplyCorrection = onApplyCorrection;
EditSubtitle.prototype.onApplyCorrectionForSpelling =
  onApplyCorrectionForSpelling;
EditSubtitle.prototype.onApplyCorrectionForGrammar =
  onApplyCorrectionForGrammar;
EditSubtitle.prototype.onApplyCorrectionForSpellingEnglish =
  onApplyCorrectionForSpellingEnglish;
EditSubtitle.prototype.onAddWordToDictionary = onAddWordToDictionary;
EditSubtitle.prototype.onIgnoreWordForCorrection = onIgnoreWordForCorrection;
EditSubtitle.prototype.onIgnoreSuggestForCorrection =
  onIgnoreSuggestForCorrection;

// Char
EditSubtitle.prototype.addChar = addChar;
EditSubtitle.prototype.addCommonChar = addCommonChar;
EditSubtitle.prototype.addHebrewOrArabicChar = addHebrewOrArabicChar;
EditSubtitle.prototype.addCommonHebrewOrArabicChar = addCommonHebrewOrArabicChar;
EditSubtitle.prototype.addSpace = addSpace;
EditSubtitle.prototype.addHyphen = addHyphen;
EditSubtitle.prototype.addPeriod = addPeriod;
EditSubtitle.prototype.groupWordsByUnsecableSpace = groupWordsByUnsecableSpace;
EditSubtitle.prototype.groupWordsWithoutSpace = groupWordsWithoutSpace;
EditSubtitle.prototype.onConversionToInitial = onConversionToInitial;
EditSubtitle.prototype.onUpperOrLowerCase = onUpperOrLowerCase;
EditSubtitle.prototype.onReturnToLineWithHypen = onReturnToLineWithHypen;
EditSubtitle.prototype.removeUnsecableSpace = removeUnsecableSpace;
EditSubtitle.prototype.addQuotes = addQuotes;
EditSubtitle.prototype.addApostrophes = addApostrophes;
EditSubtitle.prototype.addOrRemoveLetter = addOrRemoveLetter;
EditSubtitle.prototype.invertPeriodAndComma = invertPeriodAndComma;
EditSubtitle.prototype.invertALetter = invertALetter;
EditSubtitle.prototype.hyphenateTwoWords = hyphenateTwoWords;
EditSubtitle.prototype.replaceHyphenate = replaceHyphenate;
EditSubtitle.prototype.addOrRemoveLetterWithApostrophe =
  addOrRemoveLetterWithApostrophe;
EditSubtitle.prototype.addOrRemoveApostropheToLetter =
  addOrRemoveApostropheToLetter;
EditSubtitle.prototype.replaceLetter = replaceLetter;
EditSubtitle.prototype.addOrRemoveLeToWord = addOrRemoveLeToWord;

export default EditSubtitle;
